/* VeraFace Pro — progressive enhancement. Scoped, no deps. */
(function () {
  'use strict';
  var d = document;
  function qa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  /* ---------- Single-H1 guard ---------- */
  function demoteForeignH1() {
    qa('h1').forEach(function (h) {
      if (h.closest('.vf')) return;
      var div = d.createElement('div');
      div.className = h.className;
      div.id = h.id || '';
      div.innerHTML = h.innerHTML;
      h.replaceWith(div);
    });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { setTimeout(demoteForeignH1, 900); });
  else setTimeout(demoteForeignH1, 900);
  new MutationObserver(function () { setTimeout(demoteForeignH1, 50); }).observe(d.body, { childList: true, subtree: true });

  /* ---------- CTA analytics ---------- */
  function track(name, props) {
    try {
      var payload = Object.assign({ product: 'Zemits VeraFace Pro' }, props || {});
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, payload);
      }
      d.dispatchEvent(new CustomEvent('vf:' + name, { detail: payload, bubbles: true }));
    } catch (e) { /* no-op */ }
  }
  qa('[data-vf-cta]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      track('vf_cta_click', { cta_key: btn.dataset.ctaKey || 'unknown', text: (btn.textContent || '').trim().slice(0, 60) });
    });
  });

  /* ---------- FAQ open tracking ---------- */
  qa('.vf-faq__item').forEach(function (item, i) {
    item.addEventListener('toggle', function () {
      if (item.open) track('vf_faq_open', { faq_index: i + 1 });
    });
  });

  /* ---------- Specialist form ---------- */
  var form = d.querySelector('[data-vf-proform]');
  if (form) {
    var startedAt = null;
    var status = form.querySelector('[data-vf-status]');

    function setMsg(text, ok) {
      if (!status) return;
      status.textContent = text;
      status.className = 'vf-form__status is-visible ' + (ok ? 'vf-form__status--ok' : 'vf-form__status--err');
    }
    function fieldErr(input, msg) {
      var err = input.closest('.vf-field') && input.closest('.vf-field').querySelector('.vf-field__err');
      if (msg) {
        input.setAttribute('aria-invalid', 'true');
        if (err) { err.textContent = msg; err.classList.add('is-visible'); }
      } else {
        input.removeAttribute('aria-invalid');
        if (err) { err.textContent = ''; err.classList.remove('is-visible'); }
      }
    }

    qa('input, select, textarea', form).forEach(function (el) {
      el.addEventListener('input', function () { fieldErr(el, ''); });
      el.addEventListener('focus', function () {
        if (!startedAt) { startedAt = Date.now(); track('vf_specialist_form_start', {}); }
      });
    });

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (form.dataset.vfBusy === '1') return;

      if ((form.querySelector('[name="company_url"]') || {}).value) return; /* honeypot */

      var valid = true;
      var firstBad = null;
      qa('input[required], select[required], textarea[required]', form).forEach(function (el) {
        var v = (el.value || '').trim();
        var bad = !v;
        if (!bad && el.type === 'email') bad = !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
        if (!bad && el.type === 'checkbox') bad = !el.checked;
        fieldErr(el, bad ? 'This field is required.' : '');
        if (bad && !firstBad) firstBad = el;
        if (bad) valid = false;
      });
      if (!valid) {
        track('vf_specialist_form_error', {});
        if (firstBad) firstBad.focus();
        return;
      }
      if (startedAt && Date.now() - startedAt < 2500) return; /* bot speed */

      form.dataset.vfBusy = '1';
      var btn = form.querySelector('[type="submit"]');
      var btnLabel = btn ? btn.textContent : '';
      if (btn) { btn.classList.add('vf__btn--loading'); btn.setAttribute('aria-disabled', 'true'); }

      var utm = {};
      try {
        new URLSearchParams(window.location.search).forEach(function (val, key) {
          if (key.indexOf('utm_') === 0 || key === 'gclid' || key === 'fbclid') utm[key] = val;
        });
      } catch (e) { /* no-op */ }

      var body = {
        form_id: 'vf_product_advice',
        form_version: '1',
        product_handle: 'zemits-veraface-pro',
        product_name: 'Zemits VeraFace Pro',
        page_url: location.href,
        referrer: d.referrer || '',
        utm: utm,
        submitted_at_utc: new Date().toISOString()
      };
      new FormData(form).forEach(function (v, k) { body[k] = typeof v === 'string' ? v : ''; });

      track('vf_specialist_form_submit', {});

      fetch(form.dataset.vfEndpoint || '/apps/pro-apply', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json().catch(function () { return {}; }); })
        .then(function () { setMsg('Thanks — your VeraFace Pro request is in. A product specialist will contact you using the details you provided.', true); form.reset(); })
        .catch(function () { setMsg('Something went wrong sending your request. Please try again, or call us at +1-888-564-5060.', false); })
        .finally(function () {
          form.dataset.vfBusy = '0';
          if (btn) { btn.classList.remove('vf__btn--loading'); btn.removeAttribute('aria-disabled'); btn.textContent = btnLabel; }
        });
    });
  }
})();
